import {differenceInSeconds} from 'date-fns';

export const getDuration = (start: Date, end: Date, withSeconds = false) => {
  const d = differenceInSeconds(end, start);
  if (Number.isNaN(d)) return '-';
  const h = Math.floor(d / 3600);
  const m = Math.floor((d % 3600) / 60);
  if(withSeconds) {
    const s = Math.floor((d % 3600) % 60);
    if (h === 0 && m === 0) return `${s}s`;
    if (h === 0 && s === 0) return `${m}m`;
    if (m === 0 && s === 0) return `${h}h`;
    if (h === 0) return `${m}m ${s}s`;
    if (m === 0) return `${h}h ${s}s`;
    if (s === 0) return `${h}h ${m}m`;
    return `${h}h ${m}m ${s}s`;
  }
  if (h === 0 && m === 0) return '0m';
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

export const getDurationWithSeconds = (start: Date, end: Date) => {
  return getDuration(start, end, true);
};

export const formatDuration = getDuration
export const formatDurationWithSeconds = getDurationWithSeconds